/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Save_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to save shortcuts: {error}" |
*
* @param {Shortcut_Keys_Save_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_failed_toast = /** @type {((inputs: Shortcut_Keys_Save_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'enregistrement des raccourcis : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verknüpfungen konnten nicht gespeichert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare i collegamenti: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить ярлыки: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al guardar los accesos directos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`保存快捷方式失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ショートカットの保存に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शॉर्टकट सहेजने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar atalhos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save shortcuts: ${i?.error}`)
});